import React from 'react';
import { useTranslation } from 'react-i18next';
import { AbsenceDetailView } from '@/components/AbsenceApplication/AbsenceDetailView';
import { Modal } from '@/components/Modal';
import { ModalSize } from '@/types/components';

interface Props {
  applicationId: number;
  onClose: () => void;
}

export const AbsenceDetailModal: React.FC<Props> = ({
  applicationId,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      label={t('absenceApplication.result.title')}
      className="md:h-[780px]"
      size={ModalSize.XLarge}
      onClose={onClose}
    >
      <AbsenceDetailView
        applicationId={applicationId}
        hideBackButton
        onBack={onClose}
        onClose={onClose}
      />
    </Modal>
  );
};
